/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PhoneDto
 */
export interface PhoneDto {
    /**
     * 
     * @type {string}
     * @memberof PhoneDto
     */
    countryCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhoneDto
     */
    areaCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhoneDto
     */
    number?: string | null;
}

export function PhoneDtoFromJSON(json: any): PhoneDto {
    return PhoneDtoFromJSONTyped(json, false);
}

export function PhoneDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'areaCode': !exists(json, 'areaCode') ? undefined : json['areaCode'],
        'number': !exists(json, 'number') ? undefined : json['number'],
    };
}

export function PhoneDtoToJSON(value?: PhoneDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'countryCode': value.countryCode,
        'areaCode': value.areaCode,
        'number': value.number,
    };
}


